import React from 'react';
import { styled } from '@mui/material/styles';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LeftAppBarButton } from './LeftAppBarButton';

const StyledLeftAppBarButton = styled(LeftAppBarButton)(({ theme }) => ({
  marginLeft: theme.spacing(-2),
  paddingLeft: theme.spacing(2),
}));

export const BackButton = (props: { onClick: () => void }) => {
  const { t } = useTranslation();

  return <StyledLeftAppBarButton onClick={props.onClick} ariaLabel={t('actions.back')} icon={<ArrowBack />} />;
};
